<div class="unii-number-container">
  <div class="unii-number-item-container">
    <div class="unii-number-item-input-container">
      <mat-form-field appearance="outline" class="unii-number-form-field">
        <mat-label>Unique Ingredient Identifier (UNII) number for Single Entity</mat-label>
        <input matInput #uniiNumberInput [(ngModel)]="uniiNumber" class="unii-number unii-number-item-input"
          (keyup.enter)="updateUniiNumber($event)" (keyup.escape)="cancelUpdate()" (blur)="updateUniiNumber($event)" />
        <mat-icon matSuffix (mousedown)="clearUniiNumberInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError('uniiNumberforSingleEntity', 'pattern')">
      Invalid number entered.
    </div>
  </div>
  <div class="unii-number-info unii-number-info-text">
    Please enter the UNII code if your compound has one. If no UNII code has been assigned, please indicate that and one will be assigned for you.
  </div>
</div>